import styled from "styled-components";

import { spacing } from "../helpers/constants";

const Wrapper = styled.section`
  max-width: 760px;
  margin: ${spacing.large} auto;
`;

export default Wrapper;
